import { all, takeLatest } from 'redux-saga/effects';
import * as retailersGroupsTitlesActions from '../actions';
import fetchRetailersGroupsTitles from './worker.fetchRetailersGroupsTitles';

function* retailersGroupsTitlesSaga() {
  yield all([takeLatest([retailersGroupsTitlesActions.fetchRetailersGroupsTitles.type], fetchRetailersGroupsTitles)]);
}

export default retailersGroupsTitlesSaga;
